import { render, staticRenderFns } from "./getCode.vue?vue&type=template&id=54da2751&scoped=true"
import script from "./getCode.vue?vue&type=script&lang=js"
export * from "./getCode.vue?vue&type=script&lang=js"
import style0 from "./getCode.vue?vue&type=style&index=0&id=54da2751&prod&lang=scss&scoped=true"
import style1 from "./getCode.vue?vue&type=style&index=1&id=54da2751&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da2751",
  null
  
)

export default component.exports